export const CustomLegend = ({ chartData }) => {
  return (
    <div className="d-flex flex-row flex-wrap gap-2">
      {chartData.labels.map((label, index) => {
        const color = chartData.datasets[0].backgroundColor[index];
        return (
          <div key={label} className="d-flex align-items-center me-2">
            <div
              style={{
                width: "8px",
                height: "8px",
                backgroundColor: color,
                borderRadius: "50%",
                marginRight: "5px",
              }}
            />
            <span style={{ fontSize: "12px", whiteSpace: "nowrap" }}>
              {label}
            </span>
          </div>
        );
      })}
    </div>
  );
};
